import { Injectable, computed, inject, signal } from '@angular/core';

import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, tap } from 'rxjs';

import { UserRole } from '../models/domain.models';
import { CompanyApiService } from './company-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserRolePermissionService {
  private _roles = signal<UserRole[]>([]);
  private _permissions = signal<Set<string>>(new Set());
  private readonly ngxPermissionsService = inject(NgxPermissionsService);
  private readonly companyApi = inject(CompanyApiService);

  readonly roles = computed(() => this._roles());
  readonly permissions = computed(() => this._permissions());

  fetchAndSetRoles(userId: number): Observable<UserRole[]> {
    return this.companyApi.getUserRoles(userId).pipe(tap(roles => this.setRoles(roles)));
  }

  setRoles(roles: UserRole[]): void {
    this._roles.set(roles);

    // Extract all permissions from roles
    const allPerms = new Set<string>();
    for (const role of roles) {
      if (role.permissions) {
        for (const perm of role.permissions) {
          allPerms.add(perm.name);
        }
      }
    }

    // Load them into ngx-permissions
    const permsArray = Array.from(allPerms);
    this._permissions.set(allPerms);
    this.ngxPermissionsService.loadPermissions(permsArray);
  }

  hasPermission(permission: string): boolean {
    return this._permissions().has(permission);
  }
}
